import store from '@/store'

export default {
  getConsumptionTaxList() {
    return store.getters['Common/getTaxRateListFromState']
  },
  findConsumptionTaxById(id) {
    const list = this.getConsumptionTaxList()
    return list.find((ele) => ele.consumptionTaxId === id)
  },
  getConsumptionTaxIdInfo(id) {
    const list = this.findConsumptionTaxById(id)
    return list ? list.taxRate : ''
  }
}
